import { dispatch } from '@ngneat/effects';

import { AuthTextMap } from '../models/auth-config';
import { setAuthTextMap } from '../repositories/auth.actions';

/**
 * Update the authTextMap object of the AuthConfig with new strings for the provided keys.
 * Useful for when your application changes its display language.
 *
 * @param authTextMap Mapping of keys to translated strings used in the Auth Components
 */
export const updateAuthTextMap = (authTextMap: AuthTextMap) => {
  dispatch(setAuthTextMap({ authTextMap }));
};
